import { css } from 'styled-components';
import { CustomerVerificationViewProps } from './models';

export const CustomerVerificationView = css<CustomerVerificationViewProps>(({ theme }) => {
  return css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    user-select: none;
    background-color: ${theme.colors.white};
    > .description {
      color: ${theme.colors.primaryBackground};
      width: 100%;
      margin: 0 50px;
      padding-bottom: 20px;
      display: flex;
      justify-content: center;
      color: ${theme.colors.primaryBackground};
      max-width: 650px;
      text-align: center;
    }
    > .header-icon {
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
    > .qr-container {
      display: flex;
      justify-content: center;
      padding-top: 40px;
      padding-bottom: 50px;
    }
  `;
});
